const OFFER_STATUS = {
  EXPIRED: 'Expired',
  SENT: 'Sent',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed'
}

export default OFFER_STATUS
